import { useMutation } from 'urql';
import { UnsubscribeFlexikontoDocument } from '@packages/gql/generated/shopping/UnsubscribeFlexikontoDocument';

/* GraphQL */ `
  mutation UnsubscribeFlexikonto($emailAddress: String!) {
    unsubscribeFlexikonto(unsubscribeRequest: { emailAddress: $emailAddress }) {
      ... on SubscribeResponseData {
        success
        alreadySubscribed
      }
      ... on ErrorResponse {
        errors
      }
    }
  }
`;

export const useUnsubscribeFlexikontoGql = () => {
  const [, executeMutation] = useMutation(UnsubscribeFlexikontoDocument);
  return executeMutation;
};
